import script from "./AssayMix.vue?vue&type=script&setup=true&lang=js"
export * from "./AssayMix.vue?vue&type=script&setup=true&lang=js"

import "./AssayMix.vue?vue&type=style&index=0&id=260ccc8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260ccc8e"]])

export default __exports__